import styled from 'styled-components';
import Button from 'components/common/Button';

export const StyledButton = styled(Button)`
  margin: 0;
`;
